import state from '../_state'

export default function (context) {
    context.state = state();
}